import React from 'react';
import { useResponsive } from '../../hooks/useResponsive';
import YouTubePlayerPageMobile from './YouTubePlayerPageMobile';

const YouTubePlayerPageDesktop: React.FC = () => {
  return (
    <div style={{ padding: '24px', height: '100%' }}>
      <h1>YouTube Player - Desktop View</h1>
      <p>Desktop version sẽ được implement sau</p>
    </div>
  );
};

const YouTubePlayerPage: React.FC = () => {
  const { isMobile } = useResponsive();

  return isMobile ? <YouTubePlayerPageMobile /> : <YouTubePlayerPageDesktop />;
};

export default YouTubePlayerPage;